export default {
	Slide: 'Puzzle',
	Puzzle: 'Puzzle',
	'The puzzle is open!': 'The puzzle is open!',
	'Congratulations!': 'Congratulations!',
	'You get it': 'You get it',
	'You get the task done': 'You get the task done',

	divided: 'dividend',
	divider: 'divisor',

	'AMOUNT OF ACTIONS WITH NUMBER': 'AMOUNT OF ACTIONS',

	'User with such email already exists': 'User with such email already exists',
	'Year of birth': 'Year of birth',
	Registration: 'Registration',
	'Surname of parents': 'Surname of parents',
	School: 'School',
	'Field is required': 'Field is required',
	'Select age': 'Select age',
	'No such teacher for this year': 'No such teacher for this year',
	'User with such phone number already exists':
		'User with such phone number already exists',
	'INTERNATIONAL SCHOOL': 'INTERNATIONAL SCHOOL',
	'Mental Arithmetic': 'Mental Arithmetic',
	'You are successfully registered': 'You are successfully registered',
	'Max length 20 chars': 'Max length 20 chars',
	'For children aged 5-14.': 'For children aged 5-14.',
	'Sign up for a trial lesson': 'Sign up for a trial lesson',
	'Parents name': "Parent's name",
	'Childs age': "Child's age",
	Country: 'Country',
	City: 'City',

	'Sign up': 'Sign up',
	'Open offer agreement': 'Open offer agreement',
	'Participate in online Indigo Olympiad':
		'Participate in online Indigo Olympiad',
	Participate: 'Participate',
	export: 'Export',
	expression: 'equation',
	'Congratulations! You did it! Now you can go to the following exercises':
		'Congratulations! You did it! Now you can go to the following equation',
	'Number of expression': 'Examples',
	'Action with number': 'Actions',
	wrong: 'Wrong',
	right: 'Right',
	'Only task': 'The task',
	match: {
		addition: 'Speedy numbers',
		multiply: 'Multiplication',
		divide: 'Division',
		abacus_random: 'Abacus Random',
		anzan: 'Anzan',
		negative: 'Negative numbers',
		column: 'Columns',
	},
	timeIsOver: 'Time is over',
	timer: 'Timer',
	Monday: 'Monday',
	Tuesday: 'Tuesday',
	Wensday: 'Wednesday',
	Thusday: 'Thursday',
	Friday: 'Friday',
	Saturday: 'Saturday',
	Sunday: 'Sunday',
	Signin: 'Sign in',
	'Indigo-dollars': 'Indigo-dollars',
	pageError: {
		'403': 'Access denied.',
		'404': 'This page does not exist. Try again.',
		'500': 'Server is not responding. Try again.',
	},
	error: {
		'Account deactivated': 'Your account has been deactivated',
	},
	modalNewVersion: {
		text:
			'You are using an outdated version of the site.\nUpdate is now available.',
		btn: 'Update',
	},
	CORRECT: 'CORRECT',
	games: {
		negativeNumbers: 'Negative numbers',

		pause: ' Pause',
		resume: 'Resume',

		columns: {
			name: 'Columns',
			users: 'Number of players',
			user: 'Player',
			userNames: "Player's names",
		},
	},
	Balance: 'Balance',

	modalIndigoDollars: {
		submit: 'Send',
		cancel: 'Cancel',
		title: 'Indigo-dollars',
		balance: 'Balance',
		amount: 'Amount',
		reason: 'Comment',
	},

	modalAddNotification: {
		title: 'Add notification',
		submit: 'Send',
		cancel: 'Cancel',
		empty: 'No notifications',
	},

	modalTransactionsHistory: {
		title: 'Payment History',
		type: {
			withdraw: 'Write-off',
			deposit: 'Deposit',
		},
		empty: 'The list of payments is empty',
	},
	modalCopyHomework: {
		title: 'Copy homework',
		label: 'Select the puzzle number you want to copy the homework to',
		submit: 'Copy',
		cancel: 'Cancel',
	},

	reportsPage: {
		history: {
			title: 'Change History',
			empty: 'The list is empty',
			table: {
				date: 'Date modified',
				field_name: 'Action',
				old_value: 'Old value',
				new_value: 'New value',
				user: 'Changed by user',
			},
		},
	},

	pageShop: {
		title: 'Improvement Store',
		description:
			'In the store you can purchase various improvements to the appearance of the site for indigo bucks',

		tabs: {
			all: 'All improvements',
			purchased: 'Purchased',
		},

		item: {
			off_all: 'No',

			status: {
				AVAILABLE: 'Available',
				DEPRECATED: 'Not available',
				COMING_SOON: 'Coming Soon',
			},
			is_activated: 'Selected',
			set_active: 'Select',
			unset_active: 'Disable',
			preview: 'View',
			is_free: 'Free',
			buy: 'Buy',
			bought: 'Purchased',
			purchased: 'Acquired',
		},
		empty: {
			all: 'No enhancements available',
			purchased: 'No purchased improvements',
		},

		toast: {
			error: 'An error has occurred',
			notEnoughMoney: 'Not enough money',
			itemBought: 'Improvement acquired',
			itemActivated: 'Enhancement activated',
			itemDeactivated: 'Improved deactivated',
		},
		confirmPurchase: {
			title: 'Confirm Purchase',
			message: 'Are you sure you want to buy this item?',
			confirm: 'Yes, buy',
			cancel: 'Cancel',
		},
	},
	demo: {
		title: 'Free demo lesson',
		tutorial: {
			title: 'Instruction',
			text:
				"Welcome to the online demo lesson on mental arithmetic Indigo Mental.\nIndigo Mental is the best school in mental arithmetic in the world, the company's many years of experience and the success of many students around the world at the Olympiads prove that this technique is effective, unique, working. Many parents have long been convinced of the methodology, rejoice in the successes of their children, not only in arithmetic, but in other sciences, music, sports, and note a big leap in the intellectual abilities of their child. \nMental arithmetic is a Japanese method of quick oral counting, which is rapidly developing the mental abilities and intelligence of a child. The learning process takes place on special Japanese accounts Abakus (Soroban). Mental arithmetic trains the left and right hemispheres of the brain at the same time, improving visual memory, concentration of attention, creative orientation, imaginative thinking of children.\nLet's start studying mental arithmetic, for this, click on the “PLAY” button in the video below, listen and repeat.",
		},
	},

	'Speedy numbers': 'Speedy numbers',
	'Sum Sub': 'Speedy numbers',
	disableStudent: {
		btn: 'Disconnect student',
		list: 'Students without deactivation date',
		modal: {
			title: 'Disconnecting a student',
			description: 'You are about to disable the student',
			fieldLabel: 'Select month',
			btnSubmit: 'Disable',
			btnCancel: 'Cancel',
		},
	},
}
